import { UserRound } from "lucide-react";
import { SectionHeader } from "./SectionHeader";
import { Reveal } from "./Reveal";
import { useLang } from "../i18n/LanguageContext";

export function Team() {
  const { t } = useLang();
  return (
    <section
      id="team"
      className="relative border-t border-primary/10 bg-cream/60 px-6 lg:px-24"
    >
      <div className="container mx-auto py-16 lg:py-24">
        <SectionHeader
          eyebrow={t.team.eyebrow}
          title={t.team.title}
          align="center"
          className="mx-auto"
        />

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
          {t.team.members.map((member, i) => (
            <Reveal key={member.name} delay={i * 0.1}>
              <div className="group flex h-full flex-col items-center rounded-2xl border border-primary/10 bg-white/70 px-8 py-12 text-center transition-all duration-300 hover:-translate-y-1 hover:border-secondary/60 hover:shadow-[0_18px_40px_rgba(5,37,45,0.1)]">
                <span className="grid h-16 w-16 place-items-center rounded-full border border-secondary/40 text-secondary transition-colors group-hover:bg-secondary group-hover:text-white">
                  <UserRound className="h-8 w-8" />
                </span>
                <h3 className="mt-6 font-serif text-xl font-semibold text-primary">
                  {member.name}
                </h3>
                {member.position && (
                  <p className="mt-2 text-gold-deep/80">{member.position}</p>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
